// 별별책방 - 지사 - 원별 상세페이지
import React, { useState, useEffect, useCallback, forwardRef, useImperativeHandle } from "react";

import axios from "@app/lib/axios";

import ReactEcharts from "echarts-for-react";
import CommonVerticalBarChart from "@app/components/CommonVerticalBarChart";

import booksStyle from "../components/style";

const NurseryContentNursery = forwardRef(({ statPeriod, branchName, nurseryId, nurseryName, updateViewSubOption }, ref) => {
    const [stat, setStat] = useState(false);
    const [statOs, setStatOs] = useState(false);
    const [statContentSum, setStatContentSum] = useState(false);
    const [statClassContent, setClassContent] = useState(false);
    const [statClassContentSum, setClassContentSum] = useState(false);
    const [barChartSize, setBarChartSize] = useState(false);

    useImperativeHandle(ref, () => ({
        getExcelData(callback) {
            const excelData = {
                fileName: "별별책방_원통계",
                sheets: [
                    {
                        name: "접속",
                        title: `${nurseryName} - 접속 통계`,
                        columnTitle: ["안드로이드", "IOS"],
                        data: stat.nurseryOs ? stat.nurseryOs.map((s) => [s.pathAndroid, s.pathIos]) : [],
                    },
                    {
                        name: "콘텐츠 사용량",
                        title: `${nurseryName} - 콘텐츠 사용량 사용 통계`,
                        columnTitle: ["집콕", "프리미엄 동화", "기타 동화", "오디오북", "동요", "AR", "검색", "보관함", "홈"],
                        data: stat.nurseryContentSum
                            ? stat.nurseryContentSum.map((s) => [s.playCount1, s.playCount2, s.playCount3, s.playCount4, s.playCount5, s.playCount6, s.playCount7, s.playCount8, s.playCount9])
                            : [],
                    },
                    {
                        name: "반별 콘텐츠 실행 수",
                        title: `${nurseryName} - 반별 콘텐츠 실행 통계`,
                        columnTitle: ["반", "집콕", "프리미엄 동화", "기타 동화", "오디오북", "동요", "AR", "검색", "보관함", "홈"],
                        data: statClassContent
                            ? statClassContent.map((s) => [s.className, s.playCount1, s.playCount2, s.playCount3, s.playCount4, s.playCount5, s.playCount6, s.playCount7, s.playCount8, s.playCount9])
                            : [],
                    },
                ],
            };
            callback(null, excelData);
        },
    }));

    const initStat = () => {
        setBarChartSize(false);
        setStat(false);
        setStatOs(false);
        setStatContentSum(false);
        setClassContent(false);
        setClassContentSum(false);
    };

    const getStat = () => {
        initStat();
        axios({
            method: "POST",
            url: `/api/books_stat/book/branch/${nurseryId}/nursery/content`,
            data: {
                startDate: statPeriod.startDate,
                endDate: statPeriod.endDate,
                periodType: statPeriod.type,
            },
        })
            .then((result) => {
                if (result.data.code === 200) {
                    const stat = result.data.data;
                    var statOs = [
                        { id: "android", name: "안드로이드", value: 0 },
                        { id: "ios", name: "iOS", value: 0 },
                    ];

                    var statContentSum = [
                        { id: "playCount1", name: "집콕", value: 0 },
                        { id: "playCount2", name: "프리미엄 동화", value: 0 },
                        { id: "playCount3", name: "기타 동화", value: 0 },
                        { id: "playCount4", name: "오디오북", value: 0 },
                        { id: "playCount5", name: "동요", value: 0 },
                        { id: "playCount6", name: "AR", value: 0 },
                        { id: "playCount7", name: "검색", value: 0 },
                        { id: "playCount8", name: "보관함", value: 0 },
                        { id: "playCount9", name: "홈", value: 0 },
                    ];
                    var statClassContent = stat.classContent;
                    var statClassContentSum = stat.classContentSum;
                    if (stat.classContent.length) {
                        statOs[0].value = stat.nurseryOs[0].pathAndroid;
                        statOs[1].value = stat.nurseryOs[0].pathIos;

                        statContentSum[0].value = stat.nurseryContentSum[0].playCount1;
                        statContentSum[1].value = stat.nurseryContentSum[0].playCount2;
                        statContentSum[2].value = stat.nurseryContentSum[0].playCount3;
                        statContentSum[3].value = stat.nurseryContentSum[0].playCount4;
                        statContentSum[4].value = stat.nurseryContentSum[0].playCount5;
                        statContentSum[5].value = stat.nurseryContentSum[0].playCount6;
                        statContentSum[6].value = stat.nurseryContentSum[0].playCount7;
                        statContentSum[7].value = stat.nurseryContentSum[0].playCount8;
                        statContentSum[8].value = stat.nurseryContentSum[0].playCount9;
                    }
                    var barChartSize = 200;
                    if (statClassContent.length > 3) barChartSize = statClassContent.length * 55;

                    setBarChartSize(barChartSize);
                    setStat(stat);
                    setStatOs(statOs);
                    setStatContentSum(statContentSum);
                    setClassContent(statClassContent);
                    setClassContentSum(statClassContentSum);
                } else {
                    alert(result.data && result.data.msg ? result.data.msg : "통계 정보를 가져오는데 실패하였습니다.\n지속 발생시 관리자에게 문의해주세요.");
                }
            })
            .catch((error) => {
                console.log(error);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            });
    };
    useEffect(() => {
        getStat();
        return () => {};
    }, [statPeriod]);

    const optionOs = {
        tooltip: {
            trigger: "item",
            formatter: (param) => {
                return param.data ? param.data.name + " : " + param.data.value.toLocaleString() + " (" + Math.ceil(param.percent) + "%)" : "";
            },
        },
        series: {
            type: "pie",
            data: statOs,
            radius: "95%",
            center: ["40%", "50%"],
            labelLine: {
                show: false,
            },
            label: {
                show: false,
                position: "center",
            },
        },
        legend: {
            show: true,
            data: ["안드로이드", "iOS"],
            x: "right",
            y: "bottom",
            orient: "vertical",
            align: "left",
            formatter: (name) => {
                const s = statOs.find((s) => s.name === name);
                if (s) {
                    return `${name} - ${s.value}`;
                }
                return name;
            },
        },
        color: ["#60d7c5", "#3861a5"],
    };

    const optionContentSum = {
        tooltip: {
            trigger: "item",
            backgroundColor: "rgba(50,50,50,0.9)",
            formatter: (params, chart, test) => {
                const total = statContentSum ? statContentSum.reduce((ac, current) => ac + current.value, 0) : 0;
                const tip = statContentSum
                    ? statContentSum
                          .map(
                              (s, idx) =>
                                  `<div class='row' style='margin-left: 3px;margin-right: 3px;width: 200px'>${`<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${booksStyle.seriesBookColor.normal[idx]};"></span>`}${
                                      s.name
                                  }: ${s.value.toLocaleString()}, ${((s.value / total) * 100).toFixed(1)}%</div>`
                          )
                          .join("")
                    : "";
                return tip + `<div style="height: 1px;border-bottom: 1px solid #aaa"></div><div class='row font-weight-bold m-1' style='width: 200px'>합계: ${total.toLocaleString()}</div>`;
            },
        },
        series: [
            {
                type: "pie",
                data: statContentSum,
                radius: "95%",
                center: ["42%", "50%"],
                labelLine: {
                    show: false,
                },
                label: {
                    show: false,
                    position: "center",
                },
                color: booksStyle.seriesBookColor.normal,
            },
        ],
        legend: {
            orient: "vertical",
            x: "right",
            y: "top",
        },
    };

    const chartOptionContentSum = {
        grid: {
            top: "12%",
            left: "10%",
            right: "5%",
            bottom: "10%",
        },
        yAxis: { field: "className" },
        xAxis: {
            name: "건",
            series: booksStyle.seriesBookChart,
        },
        stacks: [{ stack: "base", showSum: false, showSumTooltip: true, showPercent: true }],
        showLegend: true,
        legend: {
            x: "right",
            y: "top",
        },
        sort: false,
        grid: {
            top: "12%",
            left: "10%",
            right: "5%",
            bottom: "10%",
        },
    };

    return (
        <div className="stat-branch-content">
            <div className="row mb-3">
                <div className="col-xl-5 col-lg-5 col-md-12 col-sm-12 col-12">
                    <div className="card">
                        <div className="card-header d-flex" style={{ padding: "5px 20px" }}>
                            <h5 className="card-header-title">접속 경로</h5>
                        </div>
                        <div className="card-body" style={{ height: "auto" }}>
                            <ReactEcharts theme="macarons" option={optionOs} style={{ height: `220px` }} />
                        </div>
                    </div>
                </div>
                <div className="col-xl-7 col-lg-7 col-md-12 col-sm-12 col-12">
                    <div className="card">
                        <div className="card-header d-flex" style={{ padding: "5px 20px" }}>
                            <h5 className="card-header-title">콘텐츠 사용량</h5>
                        </div>
                        <div className="card-body" style={{ height: "auto" }}>
                            <div className="row"></div>
                            <div className="row">
                                <div className="col-xl-11 col-lg-11 col-md-12 col-sm-12 col-12">
                                    <ReactEcharts theme="macarons" option={optionContentSum} style={{ height: `220px` }} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div className="card">
                        <div className="card-header d-flex" style={{ padding: "5px 20px" }}>
                            <h5 className="card-header-title">반 별 콘텐츠 실행 수</h5>
                        </div>
                        <div className="card-body" style={{ height: `${barChartSize}px` }}>
                            <CommonVerticalBarChart chartData={statClassContentSum} chartOption={chartOptionContentSum} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
});

export default NurseryContentNursery;
